(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["AMP TI-M"] = factory();
	else
		root["AMP TI-M"] = factory();
})(globalThis, () => {
return 